import { lazy, Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from 'react-router-dom'
import TheRescuerURL from '../session/rescuer'
import companyRoutes from './path/company-routes'
import partnerRoutes from './path/partner-routes'
import deliveryRoutes from './path/delivery-routes'
import Loading from '../main/parts/loading'
import ProtectedRoute from './protected-route'
import Notifications from './sockets/notifications'

const AboutPage = lazy(() => import('../../../pages/about'))
const NotFoundPage = lazy(() => import('../../../pages/not-found'))
const LoginPage = lazy(() => import('../../../pages/login'))
const SupportPage = lazy(() => import('../../../pages/support'))

const AppRoutes = () => {
	const { business, type } = useSelector(({ auth }) => auth)
	const dispatch = useDispatch()
	const { selectCompany, selectCompanyType } = useSelector(
		({ companies }) => companies
	)

	return (
		<Router>
			<Notifications business={business} type={type} dispatch={dispatch} />
			<Suspense fallback={<Loading />}>
				<Routes>
					{type === 'company' && companyRoutes(business, type)}
					{type === 'partner' &&
						partnerRoutes(business, type, selectCompany, selectCompanyType)}
					{type === 'deliveries-provider' && deliveryRoutes(business, type)}
					<Route
						path='/support'
						element={
							<ProtectedRoute>
								<SupportPage
									business={type === 'company' ? business.data : business}
									type={type}
								/>
							</ProtectedRoute>
						}
					/>
					<Route path='/' element={<Navigate to='/home' />} />
					<Route path='/about' element={<AboutPage />} />
					<Route path='/not-found' element={<NotFoundPage />} />
					<Route path='/login' element={<LoginPage />} />
					<Route
						path='*'
						element={
							business ? (
								<Navigate to='/not-found' />
							) : (
								<TheRescuerURL to='/login' />
							)
						}
					/>
				</Routes>
			</Suspense>
		</Router>
	)
}

export default AppRoutes
